import React from 'react'
import PropTypes from 'prop-types'

import logo from '@cred/global-assets/images/logos/credible/logo-blue.svg'

import styles from './styles.module.scss'

const PoweredBy = ({ stylesClassName, className }) => (
  <div className={className}>
    <p className={stylesClassName || styles.text}>
      Powered by&nbsp;
      <img src={logo} className={styles.logo} alt="Credible" />
    </p>
  </div>
)

PoweredBy.propTypes = {
  className: PropTypes.string,
  stylesClassName: PropTypes.string,
}
export default PoweredBy
